var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Label } from '../private/label/label';
import { SelectElement } from './private/element';
/**
 * Component
 */
const Select = forwardRef((props, ref) => {
    const { children, disabled, label, fullWidth, flex, inputGrow, dir } = props, rest = __rest(props, ["children", "disabled", "label", "fullWidth", "flex", "inputGrow", "dir"]);
    const SelectInput = (React.createElement(SelectElement, Object.assign({ withIcon: true, fullWidth: fullWidth, disabled: disabled, dir: dir, ref: ref }, rest), children));
    return label ? (React.createElement(Label, { dir: dir, disabled: disabled, text: label, flex: flex, inputGrow: inputGrow }, SelectInput)) : (SelectInput);
});
export default Select;
